// @mui material components
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import SEO from "components/SEO";

// SEO structured data
import { buildBreadcrumbSchema } from "config/structuredData";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// About page sections
import AboutProperty from "pages/About/sections/AboutProperty";
import PropertyFeatures from "pages/About/sections/PropertyFeatures";
import MeetTheHost from "pages/About/sections/MeetTheHost";

// Data
import propertyData from "pages/Home/sections/data/propertyData";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function About() {
  return (
    <>
      <SEO
        title="About the Property"
        description="Learn about Stalley Beach House, a 6-bedroom beachfront villa near Jacó, Costa Rica. Meet your hosts and discover the pool, kayaks, cook, maid and SUVs included."
        path="/about"
        imageAlt="About Stalley Beach House, a beachfront villa in Costa Rica"
        schema={buildBreadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "About", path: "/about" },
        ])}
      />
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="25vh"
        width="100%"
        variant="gradient"
        bgColor="info"
        sx={{
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <MKTypography variant="h2" component="h1" color="white" textAlign="center">
            About Stalley Beach House
          </MKTypography>
          <MKTypography variant="body1" color="white" textAlign="center" opacity={0.8} mt={1}>
            {propertyData.location.city}, {propertyData.location.state} &middot;{" "}
            {propertyData.location.country}
          </MKTypography>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <AboutProperty />
        <PropertyFeatures />
        <MeetTheHost />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default About;
